import { getSupportCenterDomain } from '@va/dashboard/selectors/customization';
import { SettingsHeading } from '@va/dashboard/ui/pages';
import { GlobeIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { contributorRole } from '@va/standalone/shared/selectors';
import { InputWithSubsection } from '@va/ui/design-system';
import Skeleton from 'react-loading-skeleton';
import { useSelector } from 'react-redux';
import { EmailListItems } from '../components';
import { TrafficAlertsToggle } from './TrafficAlertsToggle';
import useTrafficAlertsPreferences from './useTrafficAlertsPreferences';

export const TrafficAlerts = () => {
  const translate = useTranslate();
  const supportCenterDomain = useSelector(getSupportCenterDomain);
  const {
    allEmails,
    emailAddress,
    onChangeEmail,
    isSaveEmailButtonDisabled,
    isTrafficAlertSettingsLoading,
    isTrafficAlertSettingsUpdateSucceeded,
    formError,
    onSaveEmail,
    onRemoveEmail,
    onResendEmailConfirmation,
  } = useTrafficAlertsPreferences();

  const isContributor = useSelector(contributorRole);

  const cardHeading = (
    <SettingsHeading
      title={translate('form.trafficAlerts.title')}
      subText={translate('form.trafficAlerts.desc')}
      tooltip={translate('card.trafficAlerts.tooltip', { supportCenterDomain })}
    />
  );

  if (isTrafficAlertSettingsLoading) {
    return (
      <div className='gap-18px'>
        {cardHeading}
        <div className='flex flex-col gap-2'>
          <Skeleton className='h-72 rounded-18' />
          <Skeleton className='h-72 rounded-18' />
          <Skeleton className='h-72 rounded-18' />
          <Skeleton className='h-72 rounded-18' />
        </div>
      </div>
    );
  }

  return (
    <div className='flex flex-col gap-18px'>
      {cardHeading}
      <div className='flex flex-col gap-3'>
        <InputWithSubsection
          disabled={isContributor}
          infoTooltip={isContributor ? translate('tooltips.contributorRole') : undefined}
          isLoading={isSaveEmailButtonDisabled}
          onSubmit={onSaveEmail}
          icon={<GlobeIcon color='#3C3C3C' />}
          successSubmit={isTrafficAlertSettingsUpdateSucceeded}
          inputProps={{
            value: emailAddress,
            onChange: onChangeEmail,
            placeholder: translate('card.trafficAlerts.addEmail.placeholder'),
            name: 'emailAddressInput',
            label: translate('card.trafficAlerts.addEmail.label'),
          }}
          error={formError}
          listItemWrapperClass='grid-cols-1!'
          onRemove={() => {}}
          listItems={[]}
          itemsLabel={''}
        >
          <EmailListItems
            isLoading={isTrafficAlertSettingsLoading}
            listItems={allEmails ?? []}
            onRemoveClick={onRemoveEmail}
            onResendEmailConfirmation={onResendEmailConfirmation}
          />
        </InputWithSubsection>

        <TrafficAlertsToggle />
      </div>
    </div>
  );
};
